export default "__VITE_ASSET__CJNZdlZ5__"